const TASK_SLA_GROUPS_URL = '/api/taskSlaGroups';

const toTaskSlaLevel = ({ sla, assignmentRule, ...level }) => ({
  ...level,
  duration: sla,
  assignmentType: assignmentRule?.type ?? null,
  assignToSingleUser: assignmentRule?.assignToSingleUser ?? false,
});

const toTaskSlaGroup = ({ levels, ...slaGroup }) => ({
  ...slaGroup,
  levels: levels ? levels.map(toTaskSlaLevel) : [],
});

export class TaskSlaGroupApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTaskSlaGroup({ taskSlaGroupId }) {
    const response = await this.#http.get(`${TASK_SLA_GROUPS_URL}/${taskSlaGroupId}`, {
      params: { withLevels: true },
    });

    return { ...response, data: toTaskSlaGroup(response.data) };
  }

  async getTaskSlaGroupsByApplicationId({ applicationId }) {
    return this.#http.get(`${TASK_SLA_GROUPS_URL}/application/${applicationId}`);
  }
}
